import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Sizes/CreateDialog';
import { Size } from '@/models/Size';

@Component<Sizes>({
  components: {
    CreateDialog,
  },
})
export default class Sizes extends Vue {

  protected selectedSize: Size | null = null;
  protected isCreatingSize: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Size(),
      name: {
        singular: 'Size',
        plural: 'Sizes',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Maison size',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
        },
        {
          text: 'Maison size shortcode',
          value: 'short_name',
          sortable: {
            key: 'short_name',
            order: 'ASC',
          },
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, size: Size) => {
            this.selectedSize = size;
            this.isCreatingSize = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, size: Size) => {
            this.selectedSize = size;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingSize = true;
      }
    };
  }

  protected get sizesDatatable(): DataTable|null {
    const dataTable = this.$refs.sizesDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedSize as Size).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this Maison size?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedSize) {
              return;
            }

            this.selectedSize
              .delete()
              .then((response: any) => {
                if (response) {
                  this.sizesDatatable ? this.sizesDatatable.refresh(true) : null;
                  this.selectedSize = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedSize = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingSize')
  protected isCreatingSizeChanged() {
    if(!this.isCreatingSize) {
      this.selectedSize = null;
    }
  }
}
